import { render, staticRenderFns } from "./UiMultiDropdown.vue?vue&type=template&id=62850f87&scoped=true"
import script from "./UiMultiDropdown.vue?vue&type=script&lang=js"
export * from "./UiMultiDropdown.vue?vue&type=script&lang=js"
import style0 from "./UiMultiDropdown.vue?vue&type=style&index=0&id=62850f87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62850f87",
  null
  
)

export default component.exports